import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-8 p-8 md:flex-row md:p-10 lg:gap-32',
    clearSearch: 'flex h-full cursor-pointer items-center',
    loading: 'loading text-inactive block size-6'
  }
});
